// extracted by mini-css-extract-plugin
export default {"modal":"ReleaseVersion_modal__sZ4JG","header":"ReleaseVersion_header__WYAfW","title":"ReleaseVersion_title__FuXJb"};